import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ds_navbar = _resolveComponent("ds-navbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_toast = _resolveComponent("toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showNavbar)
      ? (_openBlock(), _createBlock(_component_ds_navbar, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({Component}) => [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    _createVNode(_component_toast, {
      position: "bottom-left",
      class: "toast-style",
      life: 2400000
    })
  ], 64))
}